/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useTranslation } from "next-i18next";
import { IUserSubscriptionModel, PaymentPeriod } from "@nf/common";

import { useSubscriptionPriceLabel } from "./useSubscriptionPriceLabel";

import styles from "./PaymentDetailType.module.scss";

type PaymentDetailLabelProps = {
  subscription?: IUserSubscriptionModel;
  className?: string;
};

export const PaymentDetailType = ({
  className = "mt-md",
  subscription,
}: PaymentDetailLabelProps) => {
  const { t } = useTranslation("translations");

  const priceLabel = useSubscriptionPriceLabel(subscription);
  const period = subscription?.Period;
  const isCancelled = subscription?.IsCancelled;
  const isTrial = subscription?.IsTrial;

  if (!priceLabel || isTrial) {
    return null;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <span className={styles.title}>
        {period === PaymentPeriod.HalfYear
          ? t("web_subscription_6months")
          : t(`web_offer_subscription_period_${period}`)}
      </span>
      {!isCancelled && <span className={styles.price}>{priceLabel}</span>}
    </div>
  );
};
